var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_ICON_SIZE } from './constants';
import { SvgWrapper } from './styles';
export var Icon = function (_a) {
  var color = _a.color,
    _b = _a.size,
    size = _b === void 0 ? DEFAULT_ICON_SIZE : _b,
    _c = _a.type,
    type = _c === void 0 ? 'icon-phone' : _c,
    svgProps = __rest(_a, ["color", "size", "type"]);
  return _jsx(SvgWrapper, __assign({
    role: "img",
    fill: color,
    size: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps, {
    children: _jsx("use", {
      xlinkHref: "#".concat(type)
    })
  }));
};